import { environment } from '../../../environments/environment';
import { ISeoMetaTag } from '../interfaces/seo.interface';

export const PATTERN = {
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_]).{4,15}$/
};

export const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const ALLOWEDTYPES = [
    'image/png',
    'image/jpeg',
    'application/pdf',
    'application/msword', // DOC
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
    'application/vnd.ms-excel', // XLS
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // XLSX
];

export const SORTBYFORJOB = [
    { key: 'DESC', value: 'Newest First' },
    { key: 'ASC', value: 'Oldest First' }
];
export const SORTBYFORCREATOR = [
    { key: 'mostPopular', value: 'Most Popular' },
    { key: 'latestCreated', value: 'Last Created' }
];

export const ALLOWEDKEYS = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Home',
    'End'
];

export const TABFORCLIENT = [
    {
        name: 'Active'
    },
    {
        name: 'In Progress'
    },
    {
        name: 'Completed'
    },
    {
        name: 'Direct Hire'
    }
];
export const TABFORCREATOR = [
    {
        name: 'Active'
    },
    {
        name: 'Completed'
    },
    {
        name: 'Saved'
    }
];
export const TAB_FOR_CREATOR_DASHBOARD = [
    {
        name: 'Active'
    },
    {
        name: 'Completed'
    },
    {
        name: 'Saved'
    },
    {
        name: 'Applied Proposals'
    },
    {
        name: 'Direct Hire'
    }
];

export const SORTBYFORPROJECT = [
    { key: 'newFirst', value: 'Newest First' },
    { key: 'oldFirst', value: 'Oldest First' }
];

export const COLORS = ['#7E32EA', '#F2418A', '#FFCA00', '#01C1D6', '#FF8066'];

export const QUERY_STATUS_COLORS: Record<string, string> = {
    open: '#41F273',
    closed: '#7A878F',
    new: '#FFCA00'
};

export const MESSAGES = {
    ALREADY_APPLIED: 'Job Proposal has already been submitted for this job.',
    WINDOW_CLOSED: 'Sorry! Window is closed to accept the job proposal.',
    ACCEPTING: 'We are accepting the job proposal for this job till',
    FUTURE: 'Proposal will be accepted from',
    DIRECT_HIRE: 'You have been directly hired for this project. Start date:',
    DIRECT_HIRE_REACHED_OUT: 'You have been directly reached out to for this project. Start date:'
};

export const ERROR_MESSAGES = {
    COMMON: "An error occurred. We're working to fix the issue. Please try again later."
};

export const COLORS_FOR_TAG = {
    ACCEPTING: 'tag-secondary',
    ALREADY_APPLIED: 'tag-primary'
};

export const FIREBASE_CONFIG = {
    apiKey: environment.apiKey,
    authDomain: environment.authDomain,
    projectId: environment.projectId,
    storageBucket: environment.storageBucket,
    messagingSenderId: environment.messagingSenderId,
    appId: environment.appId,
    measurementId: environment.measurementId
};

export const PROJECT_STATUS_MENU = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'active' },
    { label: 'In Progress', value: 'inProgress' },
    { label: 'Deliverable Done', value: 'deliverableDone' },
    { label: 'Completed', value: 'completed' }
];

export const PROJECT_PAYMENT_STATUS_MENU = [
    { label: 'Pending', value: 'pending' },
    { label: 'Paid', value: 'succeeded' },
    { label: 'Failed', value: 'failed' }
];

export const USER_TYPE_MENU = [
    { label: 'All', value: '' },
    { label: 'Client', value: 'client' },
    { label: 'Creator', value: 'creator' }
];

export const SUBSCRIPTION_TYPE_MENU = [
    { label: 'All', value: '-1' },
    { label: 'Free', value: '' },
    { label: 'Monthly', value: 'monthly' }
];

export const STATUS = [
    { label: 'All', value: '' },
    { label: 'New', value: 'new' },
    { label: 'Opened', value: 'open' },
    { label: 'Closed', value: 'closed' }
];

export const HEADER_FOR_DASHBOARD = {
    INVOICES: 'My Invoices',
    PAYMENT: 'My Payments'
};

export const TAB_FOR_ADMIN_DASHBOARD = [
    {
        name: 'Generated Invoices'
    },
    {
        name: 'Transfer Funds'
    },
    {
        name: 'User List'
    },
    {
        name: 'Stripe Invoices'
    }
];

export const TAB_FOR_ADMIN_DASHBOARD_GRAPH = [
    {
        name: 'Platform Overview'
    },
    {
        name: 'Client Success'
    },
    {
        name: 'Creator Success'
    },
    {
        name: 'Finance Success'
    },
    {
        name: 'Favorites'
    }
];

export const COLORS_FOR_PAYMENT_STATUS = {
    OVERDUE: 'tag-primary',
    PAID: 'tag-green',
    INPROGRESS: 'tag-blue'
};

export const FILE_SIZE = 50 * 1024 * 1024;

export const MAX_FILE_COUNT = 2;

// Upload size limits for different content types
export const PORTFOLIO_UPLOAD_SIZE = 50 * 1024 * 1024; // 50 MB for portfolio items
export const DELIVERABLE_UPLOAD_SIZE = 4 * 1024 * 1024 * 1024; // 4 GB for project deliverables
export const STORAGE_LIMIT_MSG = 'You have exceeded allowed storage limit. You may share the link to a storage service';

export const FILE_VALIDATION = 'Maximum of two files should be uploaded at a time, with each file being no larger than 50 MB in size.';

export const PROJECT_DESC = `Describe your project, goals, and creative needs in detail. The more
 information you provide, the better matches you’ll receive`;

export const REFERENCES_DESC = 'Add links or describe the creative style you’re looking for';

export const PERMISSION_ERROR = `You don't have permission to view this page`;

export const PAYMENT_REQUIRED_ERROR =
    'Please ensure all fields are complete: card information, city, state, country, and address are required to proceed with payment.';

export const CHECK_ACTIVE_SUBSCRIPTION = 'You need an active or trial subscription to create a project.';

export const SEO_DATA: Record<string, ISeoMetaTag> = {
    '/job-search': {
        title: 'Creator Hub - Find Work',
        description: 'Welcome to Mango'
    },
    '/creator-list': {
        title: 'Creator Hub - Find Talent',
        description: 'Welcome to Mango'
    },
    '/': {
        title: 'Mango - Home',
        description: 'Welcome to Mango'
    }
};

export const EMPLOYMENT_DATE_RANGE = ['startMonth', 'startYear', 'endMonth', 'endYear'];

export const STRIPE_CUSTOM_ERRORS_PATTERN = {
    COUNTRY_CODE: /Country '([^']+)' is unknown/
};

export type SocialPlatformConfigConst = {
    key: string;
    link: string;
    display: string;
    placeholder: string;
    icon: string;
};

export const SOCIAL_PLATFORMS: ReadonlyArray<SocialPlatformConfigConst> = [
    {
        key: 'facebook',
        link: 'https://www.facebook.com/',
        display: 'Facebook',
        placeholder: 'https://facebook.com/your-profile',
        icon: '/assets/icon/facebook-icon.svg'
    },
    {
        key: 'instagram',
        link: 'https://www.instagram.com/',
        display: 'Instagram',
        placeholder: 'https://instagram.com/your-profile',
        icon: '/assets/icon/instagram-icon.svg'
    },
    {
        key: 'twitter',
        link: 'https://twitter.com/',
        display: 'Twitter/X',
        placeholder: 'https://twitter.com/your-profile',
        icon: '/assets/icon/twitter-icon.svg'
    },
    {
        key: 'linkedin',
        link: 'https://www.linkedin.com/in/',
        display: 'LinkedIn',
        placeholder: 'https://linkedin.com/in/your-profile',
        icon: '/assets/icon/linkedIn-icon.svg'
    },
    {
        key: 'youtube',
        link: 'https://www.youtube.com/@',
        display: 'YouTube',
        placeholder: 'https://youtube.com/@your-channel',
        icon: '/assets/icon/youtube-icon.svg'
    },
    {
        key: 'tiktok',
        link: 'https://www.tiktok.com/@',
        display: 'TikTok',
        placeholder: 'https://tiktok.com/@your-profile',
        icon: '/assets/icon/tiktok-icon.svg'
    },
    {
        key: 'github',
        link: 'https://github.com/',
        display: 'GitHub',
        placeholder: 'https://github.com/your-profile',
        icon: '/assets/icon/github-icon.svg'
    }
];

export const ANNOUNCEMENT_BANNER_MESSAGES = {
    PAYMENT: {
        title: 'Important Notice:',
        message: 'Add your payment details to apply for jobs and receive payments seamlessly.',
        link: '/creator-add-payment-details',
        linkLabel: 'Update Now'
    }
};

export const OVERVIEW_CHART_OPTIONS = [
    { label: 'Creator Join', value: 'creator-join' },
    { label: 'Client Join', value: 'client-join' },
    { label: 'Job Posted', value: 'job-posted' },
    { label: 'Value of Job Posted', value: 'value-of-jo-posted' }
];

export const CHART_OPTIONS_TIME_FRAME = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Yearly', value: 'yearly' }
];

export const CLIENT_SUCCESS_CHART_OPTIONS = [
    { label: 'Time to first proposal', value: 'time-to-first-proposal' },
    { label: 'Time to hire creator', value: 'time-to-hire-creator' },
    { label: 'Time to complete job post', value: 'time-to-complete-job-post' },
    { label: 'Engagement Metrics', value: 'engagement-metrics' }
];

export const CREATOR_SUCCESS_CHART_OPTIONS = [
    { label: 'Creators completed profiles', value: 'creators-completed-profiles' },
    { label: 'Time to submitted proposal', value: 'time-to-submitted-proposal' },
    { label: 'Proposals submitted per job', value: 'proposals-submitted-per-job' },
    { label: 'Engagement Metrics', value: 'engagement-metrics' }
];

export const FINANCE_SUCCESS_CHART_OPTIONS = [
    { label: 'Subscription Revenue', value: 'subscription-revenue' },
    { label: 'Commission Revenue', value: 'commission-revenue' },
    { label: 'Total Revenue (Subscriptions + Commission)', value: 'total-revenue' }
];
